import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

export const useChartStore = defineStore({
    id: 'chart',
    state: () => ({
        dataArray: reactive([]),
        dataEnabled: reactive([]),
        seriesValues: reactive({}),
        curveColors: reactive([]),
        currentWavelength: reactive(null),
        selectedCategory: ref('Bandpass'),
        initialized: ref(false),
        curveCounter: ref(0),
        lightCounter: ref(0),
        nodata: ref(true),
    }),
    actions: {
        init() {
            if (!this.initialized) {
                this.initColors();
                this.initialized = true;
            }
        },
        enableItem(name) {
            this.dataEnabled.push(name);
        },
        addSeries(data) {
            this.dataArray.push(data);
        },
        disableItem(name) {
            this.dataEnabled = this.dataEnabled.filter(i => i !== name);
        },
        romeveItem(itemIndex, itemName) {
            this.dataArray.splice(itemIndex, 1);
            delete this.seriesValues[itemName];
        },
        isItemEnabled(name) {
            return this.dataEnabled.includes(name);
        },
        clearAll() {
            this.dataArray = [];
            this.dataEnabled = [];
            this.seriesValues = {};
            this.currentWavelength = null;
        },
        initColors() {
            this.curveColors = ['#000000', '#ba212e', '#247db5', '#f79421', '#0da64d'];
        },
    },
});